import _get from "lodash/get";

export default function(key, replace = {}) {
    let trans = _get(window.yna.i18n, key);

    if (!trans) {
        return key;
    }

    trans = typeof trans === "string" ? trans : `${trans}`;

    Object.keys(replace).forEach(function(key) {
        trans = trans.replace(new RegExp(`\{${key}\}`, "g"), replace[key]);
    });

    return trans;
}
